import { AnnexService } from './services/AnnexService';
import { AnnexModel } from './models/AnnexModel';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { MatDialogModule } from '@angular/material/dialog';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { HomeComponent } from './components/home/home.component';
import { DoctorsComponent } from './components/doctors/doctors.component';
import { CodesComponent } from './components/codes/codes.component';
import { UnitsComponent } from './components/units/units.component';
import { ItemsComponent } from './components/items/items.component';
import { RoomsComponent } from './components/rooms/rooms.component';
import { UsersComponent } from './components/users/users.component';
import { UserPermComponent } from './components/user-perm/user-perm.component';
import { DatabankComponent } from './components/databank/databank.component';
import { PreparationOrderComponent } from './components/preparation-order/preparation-order.component';

import { LoginComponent } from './components/login/login.component';
import { ProtocolsComponent } from './components/protocols/protocols.component';
import { BookingComponent } from './components/booking/booking.component';
import { FormsModule } from '@angular/forms';
import { ReportAdminComponent } from './components/report-admin/report-admin.component';
import { ReportMedicalComponent } from './components/report-medical/report-medical.component';
import { ReportPharmaComponent } from './components/report-pharma/report-pharma.component';
import { ReportbookingComponent } from './components/reportbooking/reportbooking.component';
import { PopuppatientsearchComponent } from './components/popuppatientsearch/popuppatientsearch.component';
import { UnitsService } from './services/UnitsService';
import { URLsConfig } from './URLsConfig';
import { UnitsModel } from './models/UnitsModel';
import { AnnexComponent } from './components/annex/annex.component';
import { DoctorsModel } from './models/DoctorsModel';
import { DoctorsService } from './services/DoctorsService';
import { PatientModel } from './models/PatientsModel';
import { PatientsService } from './services/PatientsService';
import { SuppliesModel } from './models/SuppliesModel';
import { SuppliesService } from './services/SuppliesService';
import { RoomsModel } from './models/RoomsModel';
import { RoomsService } from './services/RoomsService';
import { UnitsDearchComponent } from './components/units-dearch/units-dearch.component';
import { CodessearchComponent } from './components/codessearch/codessearch.component';
import { NgxWebstorageModule } from 'ngx-webstorage';
import { RoomssearchComponent } from './components/roomssearch/roomssearch.component';
import { DoctorssearchComponent } from './components/doctorssearch/doctorssearch.component';
import { CategoryModel, ClassificationModel } from './models/ClassificationModel';
import { ClassificationCModel } from './models/ClassificationCModel';
import { ClassificationService } from './services/ClassificationService';
import { PharmGroupModel } from './models/PharmGroupModel';
import { PharmGroupService } from './services/PharmGroupService';
import { ItemsModel } from './models/ItemsModel';
import { ItemsService } from './services/ItemsService';
import { ItemssearchComponent } from './components/itemssearch/itemssearch.component';
import { UsersModel } from './models/UsersModel';
import { UsersService } from './services/UsersService';
import { CompanyModel } from './models/CompanyModel';
import { CompanyService } from './services/CompanyService';
import { ReportViewerModule } from 'ngx-ssrs-reportviewer';
import { ReportVewierComponent } from './components/report-vewier/report-vewier.component';
import { ClassificationCService } from './services/ClassificationCService';
import { GroupsModel } from './models/GroupsModel';
import { GroupsService } from './services/GroupsService';
import { UsersearchComponent } from './components/usersearch/usersearch.component';
import { Square } from './services/Square';
import { DataBankSTP1Component } from './components/data-bank-stp1/data-bank-stp1.component';
import { DatabankModel } from './models/DataBankModel';
import { DataBankService } from './services/DataBankService';
import { ReservationModel } from './models/ReservationModel';
import { ReservationService } from './services/ReservationService';
import { UserPermModel } from './models/UserPermModel';
import { UserPermService } from './services/UserPermService';
import { ProtocolHDModel } from './models/ProtocolHDModel';
import { ProtocolHDService } from './services/ProtocolHDService';
import { ProtocolDetModel } from './models/ProtocolDetModel';
import { ProtocolDetService } from './services/ProtocolDetService';
import { CanserModel } from './models/CanserModel';
import { CanserService } from './services/CanserService';
import { PathologyModel } from './models/PathologyModel';
import { PathologyService } from './services/PathologyService';
import { masterdataService } from './services/MasterdataService';
import { GovernmentsModel, HorTypeModel, ImageTypesModel, MasterdataModel, RadTypeModel } from './models/Masterdata.Model';
import { examinationComponent } from './components/examination/examination.component';
import { ProtocolsearchComponent } from './components/protocolsearch/protocolsearch.component';
import { ExaminationModel } from './models/ExaminationModel';
import { ExaminationService } from './services/ExaminationService';
import { PreparationHDModel } from './models/PreparationHDModel';
import { PreparationHDService } from './services/PreparationHDService';
import { PreparationDetModel } from './models/PreparationDetModel';
import { PreparationDetService } from './services/PreparationDetService';
import { ExaminationsearchComponent } from './components/examinationsearch/examinationsearch.component';
import { PreparationsearchComponent } from './components/preparationsearch/preparationsearch.component';
import { ReportFromToComponent } from './components/report-from-to/report-from-to.component';
import { MedicalRecordComponent } from './components/medical-record/medical-record.component';
import {MatTabsModule} from '@angular/material/tabs';
import { SearchAdvComponent } from './components/search-adv/search-adv.component';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { HttpClient } from '@angular/common/http';                         //// for change languges
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';   //// for change languges
import { TranslateHttpLoader } from '@ngx-translate/http-loader';         //// for change languges
import { MaterialModule } from './shared/material/material.module';
import { BanksSettingsComponent } from './components/banks-settings/banks-settings.component';
import { DemographicModel } from './models/DemographicModel';
import { DemographicService } from './services/DemographicService';
import { MedicalHistoryModel } from './models/MedicalHistoryModel';
import { MedicalHistoryService } from './services/MedicalHistoryService';
import { SurgicalHistoryModel, SurgTypeModel } from './models/SurgicalHistoryModel';
import { SurgicalHistoryService } from './services/SurgicalHistoryService';
import { FamilyHistoryModel } from './models/FamilyHistoryModel';
import { FamilyHistoryService } from './services/FamilyHistoryService';
import { CurrentMedicationModel } from './models/CurrentMedicationModel';
import { CurrentMedicationService } from './services/CurrentMedicationService';
import { PathInvModel } from './models/PathInvModel';
import { PathInvService } from './services/PathInvSevice';
import { ImageTypeModel, ImgInvModel } from './models/ImgInvModel';
import { ImgInvService } from './services/ImgInvService';
import { EndoInvModel, EndoTypeModel } from './models/EndoInvModel';
import { EndoInvService } from './services/EndoInvService';
import { TTTOutCocModule } from './models/TTTOutCocModule';
import { TTTOutCocService } from './services/TTTOutCocService';
import { DisStartingModel } from './models/DisStartingModel';
import { DisStartingService } from './services/DisStartingService';
import { GeneralExaminationModel } from './models/GeneralExaminationModel';
import { GeneralExaminationService } from './services/GeneralExaminationService';
import { FollowUpVisitModel } from './models/FollowUpVisitModel';
import { FollowUpVisitService } from './services/FollowUpVisitService';
import { PaymentsComponent } from './components/payments/payments.component';
import { HospitalsModel } from './models/HospitalsModel';
import { HospitalsService } from './services/HospitalsService';
import { LkpBanksModel } from './models/LkpBanksModel';
import { LkpBanksService } from './services/LkpBanksService';
import { LkpExpenssesModel } from './models/LkpExpenssesModel';
import { LkpExpenssesService } from './services/LkpExpenssesService';
import { TransactionsModel } from './models/TransactionsModel';
import { TransactionsService } from './services/TransactionsService';
import { PaymentssearchComponent } from './components/paymentssearch/paymentssearch.component';
import { RevenueComponent } from './components/revenue/revenue.component';
import { RevenuesearchComponent } from './components/revenuesearch/revenuesearch.component';
import { LkpRevenueModel } from './models/LkpRevenueModel';
import { LkpRevenueService } from './services/LkpRevenueService';
import { DrugInteractionSevice } from './services/DrugInteractionSevice';
import { DrugInteractionModel } from './models/DrugInteractionModel';
import { DrugInteractionViewComponent } from './components/drug-interaction-view/drug-interaction-view.component';
import { PreprationLineComponent } from './components/prepration-line/prepration-line.component';
import { ExAttachViewComponent } from './components/ex-attach-view/ex-attach-view.component';
import { MortalityModel } from './models/MortalityModel';
import { MortalityService } from './services/MortalityService';
import { MortalityComponent } from './components/mortality/mortality.component';
import { ProtocolEditComponent } from './components/protocol-edit/protocol-edit.component';
import { TTTFollowUpComponent } from './components/tttfollow-up/tttfollow-up.component';
import { TTTFollowUpModel } from './models/TTTFollowUpModel';
import { TTTFollowUpService } from './services/TTTFollowUpService';
import { BookingSearchComponent } from './components/booking-search/booking-search.component';
import { AccMasterComponent } from './components/acc-master/acc-master.component';
import { AccTransactionsComponent } from './components/acc-transactions/acc-transactions.component';
import { AccReportsComponent } from './components/acc-reports/acc-reports.component';
import { AccInvoiceComponent } from './components/acc-invoice/acc-invoice.component';
import { StockTrnDetModel, StockTrnHDModel } from './models/StockTrnModel';
import { StockTrnService } from './services/StockTrnService';
import { LkpStoresModel } from './models/LkpStoresModel';
import { LkpStoresService } from './services/LkpStoresService';
import { InvoiceSearchComponent } from './components/invoice-search/invoice-search.component';
import { AccInvoiceEditComponent } from './components/acc-invoice-edit/acc-invoice-edit.component';
import { RevenueTypesComponent } from './components/revenue-types/revenue-types.component';
import { RevenueTypesSearchComponent } from './components/revenue-types-search/revenue-types-search.component';
import { StoresComponent } from './components/stores/stores.component';
import { StoresSearchComponent } from './components/stores-search/stores-search.component';
import { BankSearchComponent } from './components/bank-search/bank-search.component';
import { ExpensesTypeComponent } from './components/expenses-type/expenses-type.component';
import { ExpensesSearchComponent } from './components/expenses-search/expenses-search.component';
import { StockTransactionComponent } from './components/stock-transaction/stock-transaction.component';
import { AccRepFilterComponent } from './components/acc-rep-filter/acc-rep-filter.component';
import { PatientInvoicesComponent } from './components/patient-invoices/patient-invoices.component';
import { PatientAccModel } from './models/PatientAccModel';
import { PatientAccService } from './services/PAtientAccService';
import { PatientDocumentsComponent } from './components/patient-documents/patient-documents.component';
import { PatientDocumentsModel } from './models/PatientDocumentsModel';
import { PatientDocumentsService } from './services/PatientDocumentsService';
import { PatientDocumentsEditComponent } from './components/patient-documents-edit/patient-documents-edit.component';
import { ComplainsSearchComponent } from './components/complains-search/complains-search.component';
import { ComplainsModel } from './models/ComplainsModel';
import { ComplainsService } from './services/ComplainsService';
import { ContClassComponent } from './components/cont-class/cont-class.component';
import { ContClassSearchComponent } from './components/cont-class-search/cont-class-search.component';
import { ContCategoryComponent } from './components/cont-category/cont-category.component';
import { ContCategorySearchComponent } from './components/cont-category-search/cont-category-search.component';
import { ContactsComponent } from './components/contacts/contacts.component';
import { ContactsSearchComponent } from './components/contacts-search/contacts-search.component';
import { ContactsModel } from './models/ContactsModel';
import { ContactsService } from './services/ContactsService';
import { ContactsSearchAdvComponent } from './components/contacts-search-adv/contacts-search-adv.component';
import { LeadOfSourceModel } from './models/LeadOfSourceModel';
import { DailyReservationComponent } from './components/daily-reservation/daily-reservation.component';
import { ReservationVModel } from './models/ReservationVModel';
import { ReportdialogComponent } from './components/reportdialog/reportdialog.component';
import { DialogZoomComponent } from './components/dialog-zoom/dialog-zoom.component';
import { BookingDoctorComponent } from './components/booking-doctor/booking-doctor.component';
import { ItemsearchcatComponent } from './components/itemsearchcat/itemsearchcat.component';
import { DoctorObservationComponent } from './components/doctor-observation/doctor-observation.component';
import { DiganosticComponent } from './components/diganostic/diganostic.component';
import { ClinicalExamComponent } from './components/clinical-exam/clinical-exam.component';
import { NursingAssessmentComponent } from './components/nursing-assessment/nursing-assessment.component';
import { TNMClassComponent } from './components/tnmclass/tnmclass.component';
import { MedicalHistoryVComponent } from './components/medical-history-v/medical-history-v.component';
import { MedicationPlanComponent } from './components/medication-plan/medication-plan.component';
import { ToxicityComponent } from './components/toxicity/toxicity.component';
import { TNMClassLineComponent } from './components/tnmclass-line/tnmclass-line.component';
import { ProgStepsComponent } from './components/prog-steps/prog-steps.component';
import { ReservationengineComponent } from './components/reservationengine/reservationengine.component';
import { NursingAssessmentEntryComponent } from './components/nursing-assessment-entry/nursing-assessment-entry.component';
import { PatientDocumentNewComponent } from './components/patient-document-new/patient-document-new.component';
import { DiganosticEntryComponent } from './components/diganostic-entry/diganostic-entry.component';
import { ClinicalExamEntryComponent } from './components/clinical-exam-entry/clinical-exam-entry.component';
import { ProgressNoteComponent } from './components/progress-note/progress-note.component';
import { ProgressNoteEntryComponent } from './components/progress-note-entry/progress-note-entry.component';
import { NurseAssessmentModel, NurseFollowUpModel } from './models/NurseAssessmentModel';
import { NurseAssessmentService } from './services/NurseAssessmentService';
import { ClinicalExamModel } from './models/ClinicalExamModel';
import { ClinicalExamService } from './services/ClinicalExamService';
import { ProgressNotesModel } from './models/ProgressNotesModel';
import { ProgressNotesService } from './services/ProgressNotesService';
import { DecisionModel } from './models/DecisionModel';
import { DecisionService } from './services/DecisionService';
import { DiganosisModel } from './models/DiganosisModel';
import { DiganosisService } from './services/DiganosisService';
import { CancerTreatmentModel } from './models/CancerTreatmentModel';
import { CancerTreatmentService } from './services/CancerTreatmentService';
import { AntiCancerTreatmentComponent } from './components/anti-cancer-treatment/anti-cancer-treatment.component';
import { DecisionComponent } from './components/decision/decision.component';
import { DecisionEntryComponent } from './components/decision-entry/decision-entry.component';
import { AntiCancerTreatmentEntryComponent } from './components/anti-cancer-treatment-entry/anti-cancer-treatment-entry.component';
import { ProgStepsNewComponent } from './components/prog-steps-new/prog-steps-new.component';
import { DatabankNewComponent } from './components/databank-new/databank-new.component';
import { PreparationOrderAdvComponent } from './components/preparation-order-adv/preparation-order-adv.component';
import { PreparationOrderNurseComponent } from './components/preparation-order-nurse/preparation-order-nurse.component';
import { CurrentMedicationComponent } from './components/current-medication/current-medication.component';
import { PreprationLineSupComponent } from './components/prepration-line-sup/prepration-line-sup.component';
import { InvestgationReqMode, ScanReqModel } from './models/InvestgationReqMode';
import { InvestgationReqService } from './services/InvestgationReqService';
import { DoctorObservationTabComponent } from './components/doctor-observation-tab/doctor-observation-tab.component';
import { DecisionTabComponent } from './components/decision-tab/decision-tab.component';
import { AntiCancerTreatmentTabComponent } from './components/anti-cancer-treatment-tab/anti-cancer-treatment-tab.component';
import { ProgressNoteTabComponent } from './components/progress-note-tab/progress-note-tab.component';
import { ClinicalExamTabComponent } from './components/clinical-exam-tab/clinical-exam-tab.component';
import { MedicalHistoryVTabComponent } from './components/medical-history-vtab/medical-history-vtab.component';
import { DiganosticTabComponent } from './components/diganostic-tab/diganostic-tab.component';
import { NursingAssessmentTabComponent } from './components/nursing-assessment-tab/nursing-assessment-tab.component';
import { VactionRequestComponent } from './components/vaction-request/vaction-request.component';
import { VactionRequestSearchComponent } from './components/vaction-request-search/vaction-request-search.component';
import { VacationDetModel, VacationTransModel, VacBalanceModel } from './models/VacationTransModel';
import { VacationTransService } from './services/VacationTransService';
import { UserChangePopComponent } from './components/user-change-pop/user-change-pop.component';
import { FamilyHistoryComponent } from './components/family-history/family-history.component';
import { AngularEditorComponent, AngularEditorModule } from '@kolkov/angular-editor';
import { PatientInfoComponent } from './components/patient-info/patient-info.component';
import { DoctorsSearchadvComponent } from './components/doctors-searchadv/doctors-searchadv.component';
import { PreparationLineNewComponent } from './components/preparation-line-new/preparation-line-new.component';
import { IsuranceCopmanyComponent } from './components/isurance-copmany/isurance-copmany.component';
import { InsuranceCompanyModel } from './models/InsuranceCompanyModel';
import { IsuranceCopmanyService } from './services/IsuranceCopmanyService';
import { IsuranceCopmanySearchComponent } from './components/isurance-copmany-search/isurance-copmany-search.component';
import { PatientIsuranceComponent } from './components/patient-isurance/patient-isurance.component';
import { PatientInsuranceModel } from './models/PatientInsuranceModel';
import { PatientInsuranceService } from './services/PatientInsuranceService';
import { RevenueDComponent } from './components/revenue-d/revenue-d.component';
import { DoctorFeeModel } from './models/DoctorFeeModel';
import { TreatmentGroupComponent } from './components/treatment-group/treatment-group.component';
import { TreatmentGroupSearchComponent } from './components/treatment-group-search/treatment-group-search.component';
import { TreatmentGroupDetService } from './services/TreatmentGroupDetServic';
import { TreatmentGroupHDDetModel } from './models/TreatmentGroupHDDetModel';
import { TreatmentGroupHDModel } from './models/TreatmentGroupHDModel';
import { TreatmentGroupHDService } from './services/TreatmentGroupHDService';
import { RoundAndClinicComponent } from './components/round-and-clinic/round-and-clinic.component';
import { RoundAndClinicModel } from './models/RoundAndClinicModel';
import { RoundAndClinicService } from './services/RoundAndClinicService';
import { RoundAndClinicsViweComponent } from './components/round-and-clinics-viwe/round-and-clinics-viwe.component';
import { RoundandclinicSearchComponent } from './components/roundandclinic-search/roundandclinic-search.component';
import { OtherClinicModel } from './models/OtherClinicModel';
import { OtherClinicService } from './services/OtherClinicService';
import { OtherClinicTabComponent } from './components/other-clinic-tab/other-clinic-tab.component';
import { OtherclinicentryComponent } from './components/otherclinicentry/otherclinicentry.component';
import { AuthInterceptor } from './interceptor/token.interceptor';
import { CustomersComponent } from './components/customers/customers.component';
import { CustomersSearchComponent } from './components/customers-search/customers-search.component';
import { CustomersModel } from './models/customers-model';
import { CustomersService } from './services/customers.service';
///import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';

export function createTranslateLoader(http: HttpClient) {                 //// for change languges
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');        //// for change languges
}
@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    HeaderComponent,
    HomeComponent,
    DoctorsComponent,
    CodesComponent,
    UnitsComponent,
    ItemsComponent,
    RoomsComponent,
    UsersComponent,
    UserPermComponent,
    DatabankComponent,
    PreparationOrderComponent,
    LoginComponent,
    ProtocolsComponent,
    BookingComponent,
    ReportAdminComponent,
    ReportMedicalComponent,
    ReportPharmaComponent,
    ReportbookingComponent,
    ProtocolsComponent,
    BookingComponent,
    PopuppatientsearchComponent,
    AnnexComponent,
    UnitsDearchComponent,
    CodesComponent,
    RoomssearchComponent,
    DoctorssearchComponent,
    CodessearchComponent,
    ItemssearchComponent,
    UsersComponent,
    ReportVewierComponent,
    UsersearchComponent,
    DataBankSTP1Component,
    UserPermComponent,
    ProtocolsearchComponent,
    examinationComponent,
    PreparationOrderComponent,
    ExaminationsearchComponent,
    PreparationsearchComponent,
    ReportFromToComponent,
    MedicalRecordComponent,
    ReportFromToComponent,
    SearchAdvComponent,
    BanksSettingsComponent,
    PaymentsComponent,
    PaymentssearchComponent,
    RevenueComponent,
    RevenuesearchComponent,
    DrugInteractionViewComponent,
    PreprationLineComponent,
    ExAttachViewComponent,
    MortalityComponent,
    ProtocolEditComponent,
    TTTFollowUpComponent,
    BookingSearchComponent,
    AccMasterComponent,
    AccTransactionsComponent,
    AccReportsComponent,
    AccInvoiceComponent,
    InvoiceSearchComponent,
    AccInvoiceEditComponent,
    RevenueTypesComponent,
    RevenueTypesSearchComponent,
    StoresComponent,
    StoresSearchComponent,
    BankSearchComponent,
    ExpensesTypeComponent,
    ExpensesSearchComponent,
    StockTransactionComponent,
    AccRepFilterComponent,
    PatientInvoicesComponent,
    PatientDocumentsComponent,
    PatientDocumentsEditComponent,
    ComplainsSearchComponent,
    ContClassComponent,
    ContClassSearchComponent,
    ContCategoryComponent,
    ContCategorySearchComponent,
    ContactsComponent,
    ContactsSearchComponent,
    ContactsSearchAdvComponent,
    DailyReservationComponent,
    ReportdialogComponent,
    DialogZoomComponent,
    BookingDoctorComponent,
    ItemsearchcatComponent,
    DoctorObservationComponent,
    DiganosticComponent,
    ClinicalExamComponent,
    NursingAssessmentComponent,
    TNMClassComponent,
    MedicalHistoryVComponent,
    MedicationPlanComponent,
    ToxicityComponent,
    TNMClassLineComponent,
    ProgStepsComponent,
    ReservationengineComponent,
    NursingAssessmentEntryComponent,
    PatientDocumentNewComponent,
    DiganosticEntryComponent,
    ClinicalExamEntryComponent,
    ProgressNoteComponent,
    ProgressNoteEntryComponent,
    AntiCancerTreatmentComponent,
    DecisionComponent,
    DecisionEntryComponent,
    AntiCancerTreatmentEntryComponent,
    ProgStepsNewComponent,
    DatabankNewComponent,
    PreparationOrderAdvComponent,
    PreparationOrderNurseComponent,
    CurrentMedicationComponent,
    PreprationLineSupComponent,
    DoctorObservationTabComponent,
    DecisionTabComponent,
    AntiCancerTreatmentTabComponent,
    ProgressNoteTabComponent,
    ClinicalExamTabComponent,
    MedicalHistoryVTabComponent,
    DiganosticTabComponent,
    NursingAssessmentTabComponent,
    VactionRequestComponent,
    VactionRequestSearchComponent,
    UserChangePopComponent,
    FamilyHistoryComponent,
    PatientInfoComponent,
    DoctorsSearchadvComponent,
    PreparationLineNewComponent,
    IsuranceCopmanyComponent,
    IsuranceCopmanySearchComponent,
    PatientIsuranceComponent,
    RevenueDComponent,
    TreatmentGroupComponent,
    TreatmentGroupSearchComponent,
    RoundAndClinicComponent,
    RoundAndClinicsViweComponent,
    RoundandclinicSearchComponent,
    OtherClinicTabComponent,
    OtherclinicentryComponent,
    CustomersComponent,
    CustomersSearchComponent,
  ],

  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    MatTabsModule,
    MaterialModule,
    BrowserAnimationsModule,
    HttpClientModule,
    NgxWebstorageModule.forRoot(),
    //NgIdleKeepaliveModule.forRoot(),
    ReportViewerModule,
    AngularEditorModule,

    //// for change languges
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    })
    ///// for change languges
  ],
  providers: [
    UnitsService,
    URLsConfig,
    UnitsModel,
    UnitsService,
    DoctorsModel,
    DoctorsService,
    PatientModel,
    PatientsService,
    SuppliesModel,
    SuppliesService,
    RoomsModel,
    RoomsService,
    ClassificationService,
    ClassificationModel,
    ClassificationCService,
    ClassificationCModel,
    PharmGroupModel,
    PharmGroupService,
    ItemsModel,
    ItemsService,
    UsersModel,
    UsersService,
    CompanyModel,
    CompanyService,
    GroupsModel,
    GroupsService,
    Square,
    DatabankModel,
    DataBankService,
    ReservationModel,
    ReservationService,
    UserPermModel,
    UserPermService,
    ProtocolHDModel,
    ProtocolHDService,
    ProtocolDetModel,
    ProtocolDetService,
    PreparationHDModel,
    PreparationHDService,
    PreparationDetModel,
    PreparationDetService,
    AnnexModel,
    AnnexService,
    DemographicModel,
    DemographicService,
    MedicalHistoryModel,
    MedicalHistoryService,
    SurgicalHistoryModel,
    SurgicalHistoryService,
    FamilyHistoryModel,
    FamilyHistoryService,
    CurrentMedicationModel,
    CurrentMedicationService,
    PathInvModel,
    PathInvService,
    ImgInvModel,
    ImgInvService,
    ImageTypeModel,
    EndoInvModel,
    EndoInvService,
    EndoTypeModel,
    TTTOutCocModule,
    TTTOutCocService,
    DisStartingModel,
    DisStartingService,
    ProtocolDetService,CanserModel,CanserService,PathologyModel,PathologyService,masterdataService,MasterdataModel,
    ExaminationModel,ExaminationService,
    GeneralExaminationModel,GeneralExaminationService,
    FollowUpVisitModel,FollowUpVisitService,
    HospitalsModel,HospitalsService,
    LkpBanksModel,LkpBanksService,
    LkpExpenssesModel,LkpExpenssesService,
    TransactionsModel,TransactionsService,
    LkpRevenueModel,LkpRevenueService,
    DrugInteractionModel,DrugInteractionSevice,
    MortalityModel,MortalityService,
    TTTFollowUpModel,TTTFollowUpService,
    StockTrnHDModel,StockTrnDetModel,StockTrnService,LkpStoresModel,LkpStoresService,
    PatientAccModel,PatientAccService,PatientDocumentsModel,PatientDocumentsService,ImageTypesModel,GovernmentsModel,
    ComplainsModel,ComplainsService,CategoryModel,ContactsModel,ContactsService,LeadOfSourceModel,ReservationVModel,
    RadTypeModel,HorTypeModel,NurseAssessmentModel,NurseAssessmentService,ClinicalExamModel,ClinicalExamService,
    ProgressNotesModel,ProgressNotesService,DecisionModel,DecisionService,DiganosisModel,DiganosisService,CancerTreatmentModel,CancerTreatmentService,SurgTypeModel,
    PreparationDetModel,NurseFollowUpModel,InvestgationReqMode,InvestgationReqService,ScanReqModel,
    VacBalanceModel,VacationDetModel,VacationTransModel,DoctorFeeModel,
    VacationTransService,InsuranceCompanyModel,IsuranceCopmanyService,PatientInsuranceModel,PatientInsuranceService,
    TreatmentGroupDetService,TreatmentGroupHDDetModel,TreatmentGroupHDModel,TreatmentGroupHDService,
    RoundAndClinicModel,RoundAndClinicService,
    OtherClinicModel,OtherClinicService,CustomersModel,CustomersService,

{
provide: HTTP_INTERCEPTORS,
useClass: AuthInterceptor,
multi: true
}
  ],




  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
